/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

function DataTableBodyCell({
  noBorder,
  align,
  children,
  width,
  sticky,
  className,
}) {
  // tính CSS sticky dựa vào prop
  const stickySide = sticky === true ? "left" : sticky;
  const stickySx = stickySide
    ? {
        position: "sticky",
        [stickySide]: 0,
        zIndex: 2,
        backgroundColor: "#fff",
      }
    : {};

  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1}
      px={2}
      sx={({
        palette: { light },
        typography: { size },
        borders: { borderWidth },
      }) => ({
        fontSize: size.sm,
        borderBottom: noBorder
          ? "none"
          : `${borderWidth[1]} solid ${light.main}`,
        ...stickySx, // 👈 thêm dòng này
      })}
      className={[
        "cellTd",
        className,
        sticky && "sticky",
        sticky === "left" && "stickyLeft stickyTd",
        sticky === "right" && "stickyRight stickyTd",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle", width }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  sticky: null,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  sticky: PropTypes.oneOf(["left", "right", null]),
};

export default DataTableBodyCell;
